export default {
  PRIMARY_BUTTON: "PRIMARY_BUTTON",
  SECONDARY_BUTTON: "SECONDARY_BUTTON"
};
